import {css} from "styled-components";

export const Routes = {
    signup: '/signup',
    accountCreated: '/accountcreated',
    signin: '/signin',
    resetPassword: '/resetpassword',
    myStories: '/',
    sharedStories: '/shared',
    findHelp: '/',
    storyEditor: '/editor',
    storyEditorWHash: (hash, pageN) => '/editor#' + hash + '&' + pageN,
    storyEditorTitle: '/editor/title',
    storyEditorTitleWHash: (hash, pageN) => '/editor/title#' + hash + '&' + pageN,
    storyEditorLayout: '/editor/layout',
    storyEditorLayoutWHash: (hash, pageN) => '/editor/layout#' + hash + '&' + pageN,
    storyViewer: '/viewer'
};

export const Colors = {
    primary: '#F6955A',
    primaryOpaque: '#F8B997',
    primaryOpaqueLight: '#FFF8F3',
    primaryShade: '#FDF2EC',
    primaryShadeOpaque: 'rgba(253,242,236,0.39)',
    darken: 'rgba(0,0,0,0.5)',
    button: '#FF6425',
    buttonLight: '#FFFFFF',
    buttonLightHover: 'rgba(255,255,255,0.95)',
    editorSelectionOutline: 'rgba(249,199,172,0.5)',
    buttonHover: '#F6955A',
    error: '#BE0000',
};

export const FontStyles = {
    body: css`font-size: 30px;color: #4A4A4A`,
    bodyLight: css`font-size: 18px; font-weight: 500;color: white`,
    button: css`font-size: 18px; font-weight: 500;color: #FF6425;`,
    label: css`font-size: 16px; font-weight: 500;color: #FF6425;`,
    labelGray: css`font-size: 16px; font-weight: 500;color: #616161;`,
    author: css`font-size: 22px; color: white;`,
    authorPrint: css`font-size: 55px; color: white;`,
    labelLight: css`font-size: 16px; font-weight: 500;color: white;`,
    italicLight: css`font-size: 14px; font-weight: 400;color: white;font-style: italic;`,
    input: css`font-size: 16px;color: black;`,
    largeInput: css`font-size: 20px;color: #616161; font-weight: 500`,
    inputLight: css`font-size: 16px;color: #FFFFFF;`,
    menuButton: css`color:white;font-size: 25px;font-weight: 500;line-height: 35px;`,
    link: css`font-size: 16px;color: ${Colors.button};`,
    linkLight: css`font-size: 16px; color: #FFFFFF;`,
    strongLight: css`font-size: 18px;font-weight: 500;color: white;`,
    titleLight: css`font-size: 25px;color: white;`,
    titleLightLarge: css`font-size: 40px;color: white;`,
    storyTitle: css`font-size: 40px;color: white;font-weight: bold`,
    storyTitlePrint: css`font-size: 100px;color: white;font-weight: bold`,
    titleDarkLarge: css`font-size: 40px;color: #4A4A4A;`,
    smallPrintLight: css`color: white;font-size: 9px;line-height: 13px;`,
    error: css`color: ${Colors.error};font-size: 16px;`,
    title: css`color: #4A4A4A;font-size: 35px;line-height: 57px;`,
    titleBold: css`color: #4A4A4A;font-size: 35px;line-height: 57px;font-weight: 500;`,
    disabledPrimary: css`color: #F9BFA0;font-size: 16px;line-height: 24px;`,
    darkLabel: css`font-size: 18px; font-weight: 500;color: #616161;`,
    darkLabelLarge: css`font-size: 24px; font-weight: 500; color: #616161;`,
};

